/* Copyright (c) 2022-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  RoleInput,
  useCreateRoleMutation,
  GetRolesDocument,
} from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";
import { generateActionSuccessText } from "~/tools";

type Props = {
  onSuccess: () => void;
};

export function useCreateRole({ onSuccess }: Props) {
  const [createRoleMutation, { loading }] = useCreateRoleMutation({
    onError: () => {
      showError();
    },
    onCompleted: () => {
      onSuccess();
      showSuccess(generateActionSuccessText("Role")()("created")());
    },
    refetchQueries: [GetRolesDocument],
  });

  function createRole(data: RoleInput) {
    createRoleMutation({
      variables: {
        input: data,
      },
    });
  }

  return [createRole, loading] as const;
}
